// extracted by mini-css-extract-plugin
module.exports = {"Errors":"MarketplacesSettingsForm_Errors__3A4nv"};